(() => {
  'use strict';

  const HEADER_SELECTOR = '#nav-solid';
  const SCROLLED_CLASS = 'scrolled';
  const DEBUG = true;

  const log = (...args) => DEBUG && console.log('[custom.js]', ...args);

  const initHeaderScroll = () => {
    const header = document.querySelector(HEADER_SELECTOR);
    if (!header) {
      // log('Header not found:', HEADER_SELECTOR);
      return;
    }

    const locoScroll = window.locoScroll || null;
    let lastScrolled = null;

    const updateHeader = (scrollY) => {
      const scrolled = scrollY > 10;
      if (scrolled !== lastScrolled) {
        header.classList.toggle(SCROLLED_CLASS, scrolled);
        // log('Scrolled changed:', scrolled, 'scrollY:', scrollY);
        lastScrolled = scrolled;
      }
    };

    if (locoScroll) {
      locoScroll.on('scroll', (obj) => {
        updateHeader(obj.scroll.y);
      });

      // Initial check
      const initScrolled = locoScroll.scroll.instance.scroll.y > 10;
      updateHeader(initScrolled);
    } else {
      const scrollContainer = document.querySelector('#main-content') || window;
      const getScroll = () => (scrollContainer === window ? window.scrollY : scrollContainer.scrollTop);

      const toggleScrolledClass = () => {
        updateHeader(getScroll());
      };

      toggleScrolledClass();
      scrollContainer.addEventListener('scroll', toggleScrolledClass, { passive: true });
      // log('Header scroll listener attached to', HEADER_SELECTOR, 'on', scrollContainer);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderScroll);
  } else {
    initHeaderScroll();
  }
})();
